<template >
    <div class="vx-breadcrumb" >
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/dashboard">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
            </li>
            <li v-for="(link, index) in breadcrumb.slice(1,-1)" :key="index" class="inline-flex items-center">
                <router-link :to="link.url" v-if="link.url">{{ $t(link.i18n) || link.title }}</router-link>
                <span class="text-primary cursor-default" v-else>{{ $t(link.i18n) || link.title }}</span>
                <span class="breadcrumb-separator mx-2 flex items-start"><feather-icon :icon="'ChevronsRightIcon'" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex">
                <span v-if="breadcrumb.slice(-1)[0].active" class="cursor-default">{{ $t(breadcrumb.slice(-1)[0].i18n) || breadcrumb.slice(-1)[0].title }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'vx-breadcrumb-modified',
  props: {
    breadcrumb: {
      type: Array,
    },
  },
}
</script>
